<template>
  <div id="app">
  
    <!-- <keep-alive > -->
      <router-view v-if='$route.meta.isCache'/> 
    <!-- </keep-alive> -->
     <router-view v-if='!$route.meta.isCache'/>
    <footer-guide  v-if="$route.meta.showFooter"></footer-guide>
  </div>
</template>

<script>
import FooterGuide from './components/FooterGuide/FooterGuide'
export default {
  name: 'App',
  data () {
     return {
      
     }
  },
  created () {
      if (localStorage.getItem('kjToken') || this.cookieUtil.getCookie('kjToken')) {
         
        this.$axios.get('/api/DjUser/GetLoginInfo').then(res => {
          if(res.data.type == 1){
             //console.log(res.data)
              //const { Token } = res.data
              // console.log(Token)
              // 存储到ls
             // localStorage.setItem('kjToken', Token)
             this.$store.dispatch('getUser', res.data)
             // this.$router.push("/profile")
            }
        })
      }
  },
  methods: {
    
  },
  components: {
    FooterGuide
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .app
    width 100%
    height 100%
    background #f5f5f5
</style>



// WEBPACK FOOTER //
// src/App.vue